import { Link } from "react-router-dom"

import { PageTitle, SectionTitle, Text } from "@jewlr/storybook/info"
import { IS_NA, jewlr_t } from "helpers/application"
import {
  holidayResizeDates as getHolidayResizeDates,
  showHolidayResize,
} from "helpers/holiday"

import VerticalSizeChart from "./ring-sizing/vertical-size-chart"

const RingSizing = () => {
  const holidayResizeDates = getHolidayResizeDates()
  return (
    <div className="text-center">
      <div className="contained">
        <div className="tablet:mx-64 mx-24 mb-32">
          <Text>
            This ring sizing guide for men and women explains how to measure
            ring size accurately using standard methods, including finger
            circumference, diameter charts, and at-home tools. Learn average
            ring sizes, fit tips, and best practices to ensure a comfortable and
            secure ring fit when purchasing or gifting{" "}
            {jewlr_t("terms.jewelry")}.
          </Text>
          {showHolidayResize() && (
            <div className="tablet:mb-56 mb-32">
              <SectionTitle as="h2" className="my-24">
                FREE RESIZING
              </SectionTitle>
              <Text>
                <b>
                  For all orders placed after {holidayResizeDates.start}, we
                  have extended our FREE ring resizing period until{" "}
                  {holidayResizeDates.end}. Unsure of the size you need? Use our
                  guide below to determine the correct ring size to order.
                </b>
              </Text>
              <Text>
                We offer one FREE resizing within two full sizes of your ring,
                including engraved items. Please note there may be an additional
                charge for re-engraving, and you will be responsible for any
                related {jewlr_t("terms.shipping")} costs. If you require a
                resizing of more than two full sizes, or you are beyond the free
                resizing period, we would still be happy to complete your
                resizing for a reasonable fee.
              </Text>
              <Text>
                To have a ring resized, please follow the link to our{" "}
                <Link data-lc="ring-sizing" to="/order/resizing">
                  Request Resizing Form
                </Link>
                .
              </Text>
            </div>
          )}
        </div>
      </div>

      <div className="contained mb-32" id="size_chart">
        <div className="tablet:mx-64 mx-24 mb-32">
          <PageTitle
            as="h2"
            className="tablet:bg-[size:150px_1px] mb-32 bg-transparent"
            subtitle
          >
            RING SIZING CHART
          </PageTitle>
          <Text>
            Use the ring sizing chart below to compare finger circumference and
            diameter with standard US ring sizes. This chart helps you quickly
            identify the correct size for a precise and comfortable fit.
          </Text>
        </div>
        <VerticalSizeChart />
      </div>

      {IS_NA() && (
        <div className="contained pb-32">
          <div className="tablet:mx-64 mx-24">
            {!showHolidayResize() && (
              <>
                <SectionTitle className="mb-24">FREE RESIZING</SectionTitle>
                <Text>
                  We offer one FREE resizing (within 2 full sizes) of your ring
                  within 30 days of the original shipment date. This includes
                  items that have been engraved, though there may be an
                  additional charge for re-engraving. You will also be
                  responsible for any related {jewlr_t("terms.shipping")} cost.
                </Text>
                <Text>
                  If you require a resizing of more than 2 full sizes, or you
                  are beyond the free resizing period, we would still be happy
                  to perform the resize for you, for a reasonable fee.
                </Text>
                <Text>
                  To have a ring resized, please follow the link to our{" "}
                  <Link data-lc="ring-sizing" to="/order/resizing">
                    Request Resizing Form
                  </Link>
                  .
                </Text>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default RingSizing
